import React, { useState } from 'react'
import AuthModal from '../Auth/AuthModal'
import styles from './AboutSection.module.css'

const AboutSection = ({ isActive, onNextSection }) => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false)
  return (
    <div className={`${styles.aboutSection} ${isActive ? styles.active : ''}`}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.titleRow}>
            <h2 className={styles.title}>
              <span className={styles.titleOrange}>그림</span>
              <span className={styles.titleBlack1}>으로</span><br/>
              <span className={styles.titleBrown}>마음</span>
              <span className={styles.titleBlack2}>을 말하다.</span>
            </h2>

            <div className={styles.subtitle}>
              <p className={styles.mainText}>AI와 미술치료 기법이 만나,</p>
              <p className={styles.mainText}>나를 이해하고 돌보는 새로운 방법</p>
            </div>
          </div>

          <div className={styles.description}>
            <p>복잡한 감정은 말로 표현하기 어려울 때, 그림 한 장이 당신의 마음을 열어줍니다.</p>
            <p>'그리고너'는 검증된 미술치료 기법인 HTP, DAP 기법과 최신 AI 기술을 통해</p>
            <p>놀이처럼 가볍게 그리면서도 의미 있는 성장을 할 수 있도록 돕습니다.</p>
          </div>

          <div className={styles.greeting}>
            <div className={styles.greetingIcon}>👋</div>
            <div className={styles.greetingText}>
              <h4>지금 바로 시작해보세요.</h4>
              <p>처음이신 분이라도 기본 기능을 쉽게 시작할 수 있습니다.</p>
            </div>
            <div className={styles.greetingActions}>
              <button className={styles.primaryBtn}
              onClick={() => {
                setIsAuthModalOpen(true);
              }}
              >바로 로그인하기</button>
            </div>
          </div>

          <div className={styles.notice}>
            ⚠️ 본 서비스는 임상 진단이 아닌, 자기 성찰과 치유 경험을 돕기 위한 프로그램입니다.
          </div>
        </div>

        <div className={styles.visual}>
          <div className={styles.phoneFrame}>
            <div className={styles.phoneScreen}>
              <div className={styles.appInterface}>
                <div className={styles.appHeader}>DRAW YOU</div>
                <div className={styles.canvasArea}>
                  <svg width="200" height="150" viewBox="0 0 200 150">
                    <rect x="20" y="40" width="160" height="80" 
                          fill="none" stroke="#ddd" strokeWidth="2" rx="4" />
                    <path d="M40,60 Q70,90 100,75 T160,85" 
                          stroke="#4f46e5" strokeWidth="3" fill="none" strokeLinecap="round"
                          className={styles.drawingLine} />
                    <circle cx="50" cy="70" r="8" fill="#f59e0b" />
                    <circle cx="130" cy="90" r="6" fill="#ef4444" />
                  </svg>
                </div>
                <div className={styles.toolBar}>
                  <div className={styles.colorPalette}>
                    <span className={styles.color} style={{backgroundColor: '#ef4444'}}></span>
                    <span className={styles.color} style={{backgroundColor: '#f59e0b'}}></span>
                    <span className={styles.color} style={{backgroundColor: '#10b981'}}></span>
                    <span className={styles.color} style={{backgroundColor: '#4f46e5'}}></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
        initialMode="signin"
      />
    </div>
  )
}

export default AboutSection